import type { RestApiError } from '~/types/api-types';

export class TPSServerError extends Error {
  errorCode: number;
  data: any;

  constructor(error: RestApiError) {
    super(error.error.message); // 'Error' breaks prototype chain here
    Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    this.errorCode = error.error.errorCode;
    this.data = error.data;
  }
}
